<template>
  <div style="padding: 0 10px">
    <ScanQuery @onQuery="queryCall" ph="输入批次包">
      <el-button slot="customize" type="primary" @click="download">
        一键下载
      </el-button>
    </ScanQuery>
    <WmsTable :is-pagination="false" :columns="columns" :dataSource="dataSource">
      <template slot="pkgCode" slot-scope="{ text, record, index }">
        {{ text }}
        <div style="color: red"v-if="record.noWashingLabel">该商品无需打印水洗标</div>
      </template>
      <template slot="productImgActive" slot-scope="{ text, record, index }">
        <ImgView :src="text" width="80" height="80" />
      </template>
      <template slot="washingLabel" slot-scope="{ text, record, index }">
       <div>
        <a @click="printWashLabel(record)" style="color:#008dde">打印水洗标</a>
        <a @click="del(record, index)" style="color:#008dde;margin-left:10px">删除</a>
       </div>
       <div v-if="record.pkgNeedHangTagStickers" style="color:red">需打印吊牌贴纸，线下对应</div>
      </template>
    </WmsTable>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ScanQuery from "@/components/ScanQuery";
import ImgView from "@/components/ImgView";
import { excelExport } from "@/utils/tools";
import Calendar from "@/utils/calendar";
import { columns, dataSourceMap } from "@/views/checking/QCRequireData";
import { pkgDetail } from "@/apis/abnormal";
import { getProductMaterial, getWashedlabelWarehouse, byProductSkuList, byProductSkuList_OEM, selectApiSku, printLabelRecordLog,queryCustomerProductMsku,getSkuMaterials, getWashedlabelInfo } from "@/apis/checking";
import { print, print2 } from "@/components/PrintTemplate/index.js"
import { washlabelImages, washTemplateJson } from "@/utils/print"
import {getDefaultLabelConfig} from "@/apis/autoPrint";
import{executePrintWashlabel} from "@/utils/printWashlabel"

export default {
  name: "WashingLabelRequire",
  components: {
    ScanQuery,
    WmsTable,
    ImgView,
  },
  data() {
    return {
      columns,
      dataSource: [],
    };
  },
  mounted() {
  },
  methods: {
    queryCall: function (payload) {
      const { code } = payload;
      if (code) {
        this.getDetails(code);
      }
    },
    getDetails: function (code) {
      const isHas = this.dataSource.some((item) => item.pkgCode === code);
      if (isHas) {
        this.$message.warning("批次包已存在");
        return;
      }
      let params = {
        pkgCode: code
      }
      pkgDetail(params).then(({ code, data }) => {
        if (code === 0) {
          // this.dataSource.push(data)
          this.getMaterial(data)
        }
      })
    },
    getMaterial(pkgDetail) {
      if (!pkgDetail.orderCode) {
        this.$message.warning('无系统订单号')
        return false
      }
      // let selParams = {
      //   productSku: pkgDetail.productSku,
      //   platformOrderNo: pkgDetail.platformOrderNo
      // }
      // selectApiSku(selParams).then(({ code, data }) => {
      //   if (code === 0) {
      //     if (data) {
      //       let cache = [pkgDetail, ...this.dataSource]
      //       this.dataSource = cache
      //     } else {
      //       this.$message.warning('该商品无需打印水洗标')
      //       return false
      //     }
      //   }
      // })
      // return
      let params = {
        systemOrderNo: pkgDetail.orderCode
      }
      getProductMaterial(params).then(({ code, data }) => {
        if (code === 0) {
          let washingLabel = ''
          if (data && data.length > 0) {
            data.forEach(item => {
              washingLabel += item.materialZh
            })
            pkgDetail.washingLabel = washingLabel
            let cache = [pkgDetail, ...this.dataSource]
            this.dataSource = cache
          } else {
            // this.$message.warning('该商品无需打印水洗标')
            pkgDetail.noWashingLabel = true
            let cache = [pkgDetail, ...this.dataSource]
            this.dataSource = cache
          }
        }
      })
    },
    async printWashLabel(record) {
      executePrintWashlabel(record)
      return 
      const material = {
        JapanStation: 'materialInfoJa',
        KoreaStation: 'materialInfoKr',
        UkStation: 'materialInfoEn'
      }[record.stationCode]
      
  const data = await getWashedlabelInfo({
    systemOrderNo: 'SYSTEM24052004000012'
    // systemOrderNo: record.orderCode
  })
      //获取规格
      let selParams = {
        productSku: record.productSku,
        platformOrderNo: record.platformOrderNo,
        orderCode: record.orderCode
      }
      let shopProductPropertiesName = await selectApiSku(selParams)
      if (!shopProductPropertiesName.data || shopProductPropertiesName.code != 0) {
        shopProductPropertiesName.data = {
          shopProductSku: undefined,
          thirdItemAttribute: undefined,
        }
        // this.$message.warning('规格信息缺失，请联系采购')
      }

      //获取logo公司名公司地址
      let params = {
        customerShopId: record.customerShopId
      }
      let companyinfo = await getWashedlabelWarehouse(params)
      let hascompanyinfo = (companyinfo.code == 0 && companyinfo.data && companyinfo.data.washedLabelRespDTOList)
      // if (companyinfo.code != 0 || !companyinfo.data || !companyinfo.data.washedLabelRespDTOList) {
      //   this.$message.warning("客户未配置公司信息")
      //   return
      // }

      //获取材质
      let materialInfo
        materialInfo = await getSkuMaterials({pkgCode: record.pkgCode})
        if (materialInfo.code != 0) {
          return
        }
        if(!materialInfo.data){
          this.$message.warning("材质信息缺失，请联系采购")
          return
        }
      // if(record.productType == 2){
      //   let params = {
      //     sku: record.productSku,
      //     pageNum: 1,
      //     pageSize: 1
      //   }
      //   materialInfo = await byProductSkuList_OEM(params)
      //   if (materialInfo.code != 0 || !materialInfo.data.records || !materialInfo.data.records[0] || !materialInfo.data.records[0].materials) {
      //     this.$message.warning("材质信息缺失，请联系采购")
      //     return
      //   }
      //   materialInfo = {
      //     data: materialInfo.data.records.map(v=>{
      //       return {
      //         ...v,
      //         materialInfoEn: v.materials,
      //         materialInfoKr: v.materials,
      //         materialInfoJa: v.materials
      //       }
      //     })
      //   }
      // }else{
      //   let productSkuList = [record.productSku]
      //   materialInfo = await byProductSkuList(productSkuList)
      //   if (materialInfo.code != 0 || !materialInfo.data || !materialInfo.data[0] || !materialInfo.data[0][material]) {
      //     this.$message.warning("材质信息缺失，请联系采购")
      //     return
      //   }
      // }

      //获取b2b水洗标shopProductSku
      let b2bShopProductSku = await queryCustomerProductMsku({customerShopId:record.customerShopId,shopProductSku:record.shopProductSku})

      //打印
      let printdata = [{
        ...record,
        // ...companyinfo.data.washedLabelRespDTOList[0],
        // ...materialInfo.data[0],
        // ...shopProductPropertiesName,
        shopProductPropertiesName: shopProductPropertiesName.data.thirdItemAttribute,
        shopProductSku: shopProductPropertiesName.data.shopProductSku,
        //materialInfoJa 配置的打印模板入参是materialInfoJa，还是按materialInfoJa传过去
        materialInfoJa: materialInfo.data,
        // shopProductPropertiesName: shopProductPropertiesName.data.shopProductPropertiesName
      }]
      if (hascompanyinfo) {
        printdata = [{
          ...companyinfo.data.washedLabelRespDTOList[0],
          ...printdata[0]
        }
        ]
      }
      //如果存在 添加表头
      if (printdata[0].materialInfoJa) {
        printdata[0].materialInfoJa = this.headerTranslate(record.stationCode,'materialInfoJa') + printdata[0].materialInfoJa
      }
      if (printdata[0].shopProductPropertiesName) {
        printdata[0].productPropertiesNameParse = this.headerTranslate(record.stationCode,'productPropertiesNameParse') + printdata[0].shopProductPropertiesName
      }
      if((record.productDesignation == 3 || record.productDesignation == 2) && record.customerProductSku){
        printdata[0].shopProductSku = this.headerTranslate(record.stationCode,'shopProductSku') +  record.customerProductSku
      }else{
        printdata[0].shopProductSku = undefined
      }

      let templateJsonCache = washTemplateJson
      function templateInt(washTemplateJson) {
        templateJsonCache = JSON.parse(washTemplateJson)
        if (hascompanyinfo && companyinfo.data.washedLabelRespDTOList[0].companyLogo) {
          let imageRatio = companyinfo.data.washedLabelRespDTOList[0].imageRatio
          let options = {
            options: {
              left: imageRatio == 2 ? 8 : 41,
              top: 200,
              height: 84,
              width: imageRatio == 2 ? 150 : 84,
              src: companyinfo.data.washedLabelRespDTOList[0].companyLogo,
              // src:'https://theckbstest-oss.theckbs.com/transfer/1662448777000封面1.jpg',
            },
            printElementType: {
              title: "图片",
              type: "image",
            },
          }
          if(record.stationCode != 'JapanStation'){
            options.options.styler = function () {
                return {
                  transform: 'rotate(180deg)',
                };
              }
          }
          templateJsonCache.panels[0].printElements.push(options, ...washlabelImages);
        } else {
          templateJsonCache.panels[0].printElements.push(...washlabelImages)
        }
        return templateJsonCache
      }
      
      this.$loading = true
      console.log(record.directSaleFlag)
      this.$printPkg(2, record.systemSource, [{...printdata[0],wantPrintNum:printdata[0].amount}], templateInt,printdata[0].stationCode,record.directSaleFlag).catch(res => {
        getDefaultLabelConfig({ nodeType:2, systemSource:record.systemSource, stationCode: printdata[0].stationCode,directSaleFlag: record.directSaleFlag }).then(res=>{
          print2(templateInt(res.data.templateJson), printdata);
        })
      }).finally(()=>{
        this.$loading = false
      })
      // print2(templateJsonCache, printdata);
      printLabelRecordLog({pkgCode: record.pkgCode})
    },
    download: function () {
      // this.errorHandler("再导出！");
      const date = Calendar.d1(Date.now());
      excelExport({
        headers: [
          {
            title: "批次包号",
            dataIndex: "pkgCode",
            key: "pkgCode",
          },
          // {
          //   title: '客户名称',
          //   dataIndex: 'clientName',
          //   key: 'clientName',
          // },
          {
            title: "商品SKU",
            dataIndex: "shopProductSku",
            key: "shopProductSku",
          },
          {
            title: "商品名称",
            dataIndex: "productName",
            key: "productName",
          },
          {
            title: '商品规格',
            dataIndex: 'productProp',
            key: 'productProp',
          },
          {
            title: '数量',
            dataIndex: 'amount',
            key: 'amount',
          },
          {
            title: '水洗标',
            key: 'washingLabel',
            dataIndex: 'washingLabel',
          }
        ],
        contents: this.dataSource,
        fileName: date + "水洗标",
      });






      return
      const len = this.dataSource.length;
      while (this.dataSource.length) {
        const { pkgCode, id } = this.dataSource[0];
        this.dataSource.splice(0, 1);
        setTimeout((_) => {
          // window.open('/scm/batch/pkg/exortQualityRequire?pkgCode=' + pkgCode + '&tenant=147')
        }, 200);
        // console.log( id, this.dataSource)
      }
    },
    del(record, index) {
      console.log(record, index)
      let data = [...this.dataSource]
      data.splice(index, 1)
      this.dataSource = data
    },
    headerTranslate(stationCode,str){
      const data = {
        materialInfoJa : {
          JapanStation: '表地: ',
          KoreaStation: 'QUA: ',
          UkStation: 'Surface: ',
          default: 'Material: '
        },
        productPropertiesNameParse:{
          JapanStation: 'サイズ: ',
          KoreaStation: 'SIZE: ',
          UkStation: 'Specification: ',
          default: 'Specification: '
        },
        shopProductSku:{
          JapanStation: 'お客様SKU: ',
          KoreaStation: 'SKU: ',
          UkStation: 'Customer SKU: ',
          default: 'Customer SKU: '
        }
      }
      return data[str][stationCode] ?? data[str].default
    }
  },
};
</script>

<style scoped>

</style>
